import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const StepService = {

    getAll(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/steps${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    create(data){

        return new Promise(async (resolve, reject) => {
            axios
                .post(`/steps`,data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    show(id,params = null) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/steps/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    update(data,id) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/steps/${id}`,data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    delete(id){
        return new Promise((async (resolve, reject) => {
            axios
                .delete(`/steps/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        }));
    },
    deleteUnassigned() {
        return new Promise(async (resolve, reject) => {
            axios
                .delete(`/steps/delete-unassigned`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    sort(data){
        return new Promise(async (resolve,reject)=>{
            axios.post('/steps/sort',data)
            .then(response => {
                resolve(response.data)
            })
            .catch(e => reject(e));

        })
    },
    clone(data){
        return new Promise(async (resolve,reject)=>{
            axios.post('/steps/clone',data)
            .then(response => {
                resolve(response.data)
            })
            .catch(e => reject(e));
        })
    },
    uploadFile(id,data){
        return new Promise(async (resolve,reject)=>{
            axios.post(`/steps/${id}/upload`,data)
            .then(response => {
                resolve(response.data)
            })
            .catch(e => reject(e));
        })
    }

}

Vue.$stepService = StepService

export default StepService